import React from 'react';
import { YesNoRadio } from '../../index';
import { AddFunnelPropFromContext } from '../funnel-context';
import { LABELS as DEFAULT_LABELS, FUNNELS, INTERNATIONAL_FUNNELS } from '../../util/constants';
import { formatDecimal } from '../../util/format-decimal';
import { Stack } from '@nib/layout';
import Copy from '@nib-components/copy';
import { StandardInfoBox } from '../info-box';
const LABELS = {
  ARHI: DEFAULT_LABELS.COVERED_BY_POLICY
};
const CoveredByPolicy = props => {
  const {
    id = '',
    values,
    funnel = FUNNELS.ARHI,
    newPrice
  } = props;
  const showPriceChangeNotification = !INTERNATIONAL_FUNNELS.includes(funnel);
  const radioSelected = Boolean(values && values[id] && values[id].length);
  const showInfoBoxMessage = Boolean(values && values[id] && values[id] === 'no');
  return React.createElement(Stack, {
    space: 2
  }, React.createElement(YesNoRadio, {
    ...props,
    label: props.label || LABELS[funnel] || LABELS.ARHI,
    id: id,
    funnel: funnel
  }), showInfoBoxMessage && React.createElement(StandardInfoBox, {
    role: "status",
    withTip: true
  }, React.createElement(Copy, null, "Applicants not covered by the policy cannot claim the Australian Government Rebate on Private Health Insurance (excluding child only policies) and the employers and trustees of organisations cannot claim the Australian Government Rebate on Private Health Insurance on policies paid on behalf of employees.")), showPriceChangeNotification && radioSelected && newPrice && React.createElement(StandardInfoBox, {
    role: "status",
    withTip: !showInfoBoxMessage
  }, React.createElement(Copy, null, "Your price has been updated to reflect your changed Australian Government Rebate details. ", React.createElement("strong", null, "New price $", formatDecimal(newPrice, {
    places: 2,
    separator: ','
  }), "*."))));
};
CoveredByPolicy.defaultProps = {
  funnel: FUNNELS.ARHI
};
const CoveredByPolicyWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(CoveredByPolicy, {
  ...props
}));
export default CoveredByPolicyWithFunnel;